import Lottie from "react-lottie";
import loader from "../assets/lotties/loader.json";

const FullScreenLoader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center">
      <Lottie options={defaultOptions} height={400} width={400} />
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default FullScreenLoader;
